import { render } from "./home.vue?vue&type=template&id=0aba2102"
const script = {}

import "./home.vue?vue&type=style&index=0&id=0aba2102&lang=scss"

import exportComponent from "E:\\SonPhat\\Project\\Project_LenhDienTu\\CauHinhHoaDonDienTu_FE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__